import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import BankAnalyzerSF from '../../../components/superUser/clientTxn/BankAnalyzerSF'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import ClientTransactionListUI from '../../../components/superUser/clientTxn/ClientTransactionListUI'
import ClientTransactionHeaderUI from '../../../components/superUser/clientTxn/ClientTransactionHeaderUI'
import ClientTransactionUpdateModalSF from '../../../components/superUser/clientTxn/ClientTransactionUpdateModalSF'

const ClientTransactionListPageUI = ({ context, account, errorList, txnList, filteredTxnList,
  searchFilter, onRefreshClick, onSearchFilterChange, bankAccountList,
  onCopyToClipboard, copyToClipboardText,
  hasMore, onMoreTransactions, gettingMore, bankAccountNumber,
  financialYear, onFinancialYearChange, financialYearList,
  selectedTxn, categoryList, categoryUpdateMode, onCancelUpdateClick, onCategoryUpdateClick, onDeduplicateClick
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_txns' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!account || bankAccountNumber == null}
    account={account} bankAccountNumber={bankAccountNumber} page='clientData'
  >
    {
      (!account || bankAccountNumber == null) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='g_m_left_100 g_large'><b>Client Data - Bank</b></span>
        </div>
      }
      right={<span />}
    />
    {
      account &&
      <ClientDataNavUI account={account} page='bank' />
    }
    {
      bankAccountList && !bankAccountList.length &&
      <EmptyListUI className='g_m_top_200'
        context={context}
        createDisabledMessageLabel='No bank accounts'
      />
    }
    {
      account && bankAccountNumber && !txnList &&
      <div className='g_m_top_200'>
        <SpinnerComponentUI />
      </div>
    }
    {
      txnList &&
      <BankAnalyzerSF context={context} account={account} show={txnList.length > 0}
        onRefreshClick={onRefreshClick}
      />
    }
    {
      bankAccountList && txnList &&
      <ClientTransactionHeaderUI context={context} onRefreshClick={onRefreshClick}
        account={account} bankAccountNumber={bankAccountNumber}
        bankAccountList={bankAccountList} txnList={txnList}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        financialYearList={financialYearList} financialYear={financialYear} onFinancialYearChange={onFinancialYearChange}
      />
    }
    <div className='g_m_top_50'>
      {
        txnList && txnList.length === 0 &&
        <EmptyListUI
          context={context}
          createDisabledMessageLabel='No transactions'
        />
      }
      {
        txnList && filteredTxnList && txnList.length !== 0 &&
        <ClientTransactionListUI
          context={context}
          txnList={filteredTxnList}
          hasMore={hasMore}
          onMoreTransactions={onMoreTransactions}
          gettingMore={gettingMore}
          bankAccountNumber={bankAccountNumber}
          onCopyToClipboard={onCopyToClipboard}
          copyToClipboardText={copyToClipboardText}
          onUpdateClick={onCategoryUpdateClick}
          onDeduplicateClick={onDeduplicateClick}
        />
      }
    </div>
    {
      txnList &&
      <div className='g_m_top_200 g_muted g_tiny'>
        Update client bank accounts: /api/su/test/accounts/[accountId]/novelpatterns/s3Reports/clientBankAccounts<br />
        Update client transactions: /api/su/test/accounts/[accountId]/novelpatterns/s3Reports/transactions<br />
      </div>
    }

    <ClientTransactionUpdateModalSF context={context}
      selectedTxn={selectedTxn}
      categoryList={categoryList}
      updateMode={categoryUpdateMode}
      onCancelClick={onCancelUpdateClick} onRefreshClick={onRefreshClick}
    />

  </SuperUserAccountPageUI>

export default ClientTransactionListPageUI
